"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: credit-report/account-credit-status.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fcredit-report%2Faccount-credit-status.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.paymentStatusToJSON = exports.paymentStatusFromJSON = exports.PaymentHistoryForMonth = exports.CalendarMonth = exports.PaymentHistory = exports.AccountCreditStatus = exports.PaymentStatus = void 0;
const statement_period_1 = require("../billing/statement-period");
const amount_1 = require("../common/amount");
const protobufPackage = 'com.step.creditreport.proto';
var PaymentStatus;
(function (PaymentStatus) {
    PaymentStatus["INVALID_PAYMENT_STATUS"] = "INVALID_PAYMENT_STATUS";
    PaymentStatus["CURRENT"] = "CURRENT";
    PaymentStatus["LATE"] = "LATE";
    PaymentStatus["UNRECOGNIZED"] = "UNRECOGNIZED";
})(PaymentStatus || (exports.PaymentStatus = PaymentStatus = {}));
function createBaseAccountCreditStatus() {
    return {
        paymentHistory: [],
        openedAt: '0',
        lastPaymentDate: undefined,
        highestCreditUsed: undefined,
        paymentHistoryByMonth: [],
    };
}
exports.AccountCreditStatus = {
    fromJSON(object) {
        const message = {
            paymentHistory: globalThis.Array.isArray(object?.paymentHistory)
                ? object.paymentHistory.map((e) => exports.PaymentHistory.fromJSON(e))
                : [],
            openedAt: isSet(object.openedAt) ? globalThis.String(object.openedAt) : '0',
            paymentHistoryByMonth: globalThis.Array.isArray(object?.paymentHistoryByMonth)
                ? object.paymentHistoryByMonth.map((e) => exports.PaymentHistoryForMonth.fromJSON(e))
                : [],
        };
        if (isSet(object.lastPaymentDate)) {
            message.lastPaymentDate = globalThis.String(object.lastPaymentDate);
        }
        if (isSet(object.highestCreditUsed)) {
            message.highestCreditUsed = amount_1.Amount.fromJSON(object.highestCreditUsed);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.paymentHistory?.length) {
            obj.paymentHistory = message.paymentHistory.map((e) => exports.PaymentHistory.toJSON(e));
        }
        if (message.openedAt !== '0') {
            obj.openedAt = message.openedAt;
        }
        if (message.lastPaymentDate !== undefined) {
            obj.lastPaymentDate = message.lastPaymentDate;
        }
        if (message.highestCreditUsed !== undefined) {
            obj.highestCreditUsed = amount_1.Amount.toJSON(message.highestCreditUsed);
        }
        if (message.paymentHistoryByMonth?.length) {
            obj.paymentHistoryByMonth = message.paymentHistoryByMonth.map((e) => exports.PaymentHistoryForMonth.toJSON(e));
        }
        return obj;
    },
    create(base) {
        return exports.AccountCreditStatus.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseAccountCreditStatus();
        message.paymentHistory = object.paymentHistory?.map((e) => exports.PaymentHistory.fromPartial(e)) || [];
        message.openedAt = object.openedAt ?? '0';
        message.lastPaymentDate = object.lastPaymentDate ?? undefined;
        message.highestCreditUsed =
            (object.highestCreditUsed !== undefined && object.highestCreditUsed !== null)
                ? amount_1.Amount.fromPartial(object.highestCreditUsed)
                : undefined;
        message.paymentHistoryByMonth =
            object.paymentHistoryByMonth?.map((e) => exports.PaymentHistoryForMonth.fromPartial(e)) || [];
        return message;
    },
};
function createBasePaymentHistory() {
    return {
        billingDate: '0',
        status: PaymentStatus.INVALID_PAYMENT_STATUS,
        billingPeriod: undefined,
    };
}
exports.PaymentHistory = {
    fromJSON(object) {
        const message = {
            billingDate: isSet(object.billingDate) ? globalThis.String(object.billingDate) : '0',
            status: isSet(object.status)
                ? paymentStatusFromJSON(object.status)
                : PaymentStatus.INVALID_PAYMENT_STATUS,
        };
        if (isSet(object.billingPeriod)) {
            message.billingPeriod = statement_period_1.StatementPeriod.fromJSON(object.billingPeriod);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.billingDate !== '0') {
            obj.billingDate = message.billingDate;
        }
        if (message.status !== PaymentStatus.INVALID_PAYMENT_STATUS) {
            obj.status = paymentStatusToJSON(message.status);
        }
        if (message.billingPeriod !== undefined) {
            obj.billingPeriod = statement_period_1.StatementPeriod.toJSON(message.billingPeriod);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentHistory.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentHistory();
        message.billingDate = object.billingDate ?? '0';
        message.status = object.status ?? PaymentStatus.INVALID_PAYMENT_STATUS;
        message.billingPeriod = (object.billingPeriod !== undefined && object.billingPeriod !== null)
            ? statement_period_1.StatementPeriod.fromPartial(object.billingPeriod)
            : undefined;
        return message;
    },
};
function createBaseCalendarMonth() {
    return { month: 0, year: 0 };
}
exports.CalendarMonth = {
    fromJSON(object) {
        const message = {
            month: isSet(object.month) ? globalThis.Number(object.month) : 0,
            year: isSet(object.year) ? globalThis.Number(object.year) : 0,
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.month !== 0) {
            obj.month = Math.round(message.month);
        }
        if (message.year !== 0) {
            obj.year = Math.round(message.year);
        }
        return obj;
    },
    create(base) {
        return exports.CalendarMonth.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseCalendarMonth();
        message.month = object.month ?? 0;
        message.year = object.year ?? 0;
        return message;
    },
};
function createBasePaymentHistoryForMonth() {
    return { month: undefined, status: PaymentStatus.INVALID_PAYMENT_STATUS };
}
exports.PaymentHistoryForMonth = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.month)) {
            message.month = exports.CalendarMonth.fromJSON(object.month);
        }
        if (isSet(object.status)) {
            message.status = paymentStatusFromJSON(object.status);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.month !== undefined) {
            obj.month = exports.CalendarMonth.toJSON(message.month);
        }
        if (message.status !== undefined && message.status !== PaymentStatus.INVALID_PAYMENT_STATUS) {
            obj.status = paymentStatusToJSON(message.status);
        }
        return obj;
    },
    create(base) {
        return exports.PaymentHistoryForMonth.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBasePaymentHistoryForMonth();
        message.month = (object.month !== undefined && object.month !== null)
            ? exports.CalendarMonth.fromPartial(object.month)
            : undefined;
        message.status = object.status ?? PaymentStatus.INVALID_PAYMENT_STATUS;
        return message;
    },
};
function paymentStatusFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_PAYMENT_STATUS':
            return PaymentStatus.INVALID_PAYMENT_STATUS;
        case 1:
        case 'CURRENT':
            return PaymentStatus.CURRENT;
        case 2:
        case 'LATE':
            return PaymentStatus.LATE;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return PaymentStatus.UNRECOGNIZED;
    }
}
exports.paymentStatusFromJSON = paymentStatusFromJSON;
function paymentStatusToJSON(object) {
    switch (object) {
        case PaymentStatus.INVALID_PAYMENT_STATUS:
            return 'INVALID_PAYMENT_STATUS';
        case PaymentStatus.CURRENT:
            return 'CURRENT';
        case PaymentStatus.LATE:
            return 'LATE';
        case PaymentStatus.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.paymentStatusToJSON = paymentStatusToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=account-credit-status.js.map